import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ENV_CONFIG } from '@bn/primitives';

import { AuthService } from '../services/auth.service';

import { needsAccessKey, resolveAuthenticatedUrls } from './auth-header.utils';

@Injectable()
export class AuthHeaderInterceptor implements HttpInterceptor {
  readonly #envConfig = inject(ENV_CONFIG);
  readonly #authService = inject(AuthService);

  readonly #authenticatedUrls = resolveAuthenticatedUrls(this.#envConfig);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const PAT = this.#authService.authStoreValue?.auth_token; // Personal Access Token (bunny)

    // NOTE: no PAT, no api need => does not belong here
    if (!PAT || !needsAccessKey(request.url, this.#authenticatedUrls)) {
      return next.handle(request);
    }

    // add auth header token - PAT
    return next.handle(
      request.clone({
        headers: request.headers.set('Authorization', PAT),
      }),
    );
  }
}
